/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { kf1AuthenticatedHttpClient } from 'kfone-frontend-core';
import { API_METHODS, API_URL } from '../constants/api.constants';
import { AppEnvVariables } from '../constants/environment.constants';
import { SESSION_STORAGE_VAR } from 'constants/session-variables.constants';
import { getCookie } from 'helpers/storageHelper';
export const getConfig = async (payload: any = {}) => {
  const shortLangCode = sessionStorage.getItem('kfone_short_lang_code');
  const clientsSearchUrl = `${AppEnvVariables.API_DOMAIN}${API_URL.CONFIG}?countryCode=${shortLangCode || payload?.countryCode}&orgCodes=${payload?.orgCodes}`;
  const payloadData = {
    countryCode: payload?.countryCode,
    orgCodes: payload?.orgCodes,
    language: payload?.language,
    year: payload?.year,
  };
  const config: any = {
    method: API_METHODS.POST,
    url: clientsSearchUrl,
    data: payloadData,
  };
  const res = await kf1AuthenticatedHttpClient(config);
  return res.data;
};

export const refreshAuthToken = async () => {
  try {
    const timestamp = Date.now();
    let activeClient: any = getCookie(SESSION_STORAGE_VAR.activeClient);
    let client = activeClient ? JSON.parse(decodeURIComponent(activeClient)) : null;

    const refreshToken = sessionStorage.getItem(SESSION_STORAGE_VAR.refreshToken);
    const config = {
      url: `auth/refresh-token?timestamp=${timestamp}`,
      method: 'POST',
      baseURL: AppEnvVariables.SERVICE_URL,
      data: {
        refreshToken: refreshToken,
        clientId: client?.key,
      },
    };
    const response = await kf1AuthenticatedHttpClient(config);
    return response?.data;
  } catch (error) {
    console.error('Error in auth token validate:', error);
    throw error;
  }
};
